import React, { useState, useEffect, useCallback, forwardRef } from 'react';
import {
  MessageBox,
  MessageBoxTypes,
  MessageBoxActions,
  CheckBox,
  WrappingType,
  ValueState,
} from '@ui5/webcomponents-react';
import eurekaMgrs from '@eureka/ui-managers';

export const eventBus = eurekaMgrs.eventBus;

const DEFAULT_PROPS = {
  actions: [MessageBoxActions.OK, MessageBoxActions.Cancel],
  open: false,
  type: MessageBoxTypes.Warning,
  checkBoxText: "Don't show again",
  checkBoxValueState: ValueState.None,
  checkBoxWrap: WrappingType.None,
};

export const handleClose = (
  e,
  appName,
  preferenceKey,
  notShow,
  userPreferenceHandler,
  setOptionalMessageBoxProps,
  closeCallback,
) => {
  if (appName && preferenceKey && typeof userPreferenceHandler === 'function') {
    userPreferenceHandler(appName, preferenceKey, notShow);
  }
  setOptionalMessageBoxProps({ ...DEFAULT_PROPS, open: false });
  if (typeof closeCallback === 'function') {
    closeCallback(e);
  }
};

export default forwardRef((props, ref) => {
  const [notShow, setNotShow] = useState(false);
  const [optionalMessageBoxProps, setOptionalMessageBoxProps] = useState({});

  const {
    appName,
    preferenceKey,
    open,
    // actions, // depends on @ui5/webcomponents-react:0.10.1
    closeCallback,
    userPreferenceHandler,
    icon,
    title,
    type,
    content,
    checkBoxText,
    checkBoxValueState,
    checkBoxWrap,
    checkBoxStyle,
    ...restProps
  } = optionalMessageBoxProps;

  const messageBoxHandler = useCallback(
    config =>
      config.content && setOptionalMessageBoxProps({ ...DEFAULT_PROPS, ...config, open: true }),
    [],
  );

  const onNotShowChange = () => setNotShow(notShowBool => !notShowBool);

  useEffect(() => {
    eventBus.on('on-optional-message-box', messageBoxHandler);
    return () => {
      eventBus.detach('on-optional-message-box', messageBoxHandler);
    };
  }, [messageBoxHandler]);
  return (
    <MessageBox
      {...restProps}
      // actions={actions}
      open={open}
      onClose={e =>
        handleClose(
          e,
          appName,
          preferenceKey,
          notShow,
          userPreferenceHandler,
          setOptionalMessageBoxProps,
          closeCallback,
        )
      }
      icon={icon}
      titleText={title}
      type={type}
      ref={ref}
      data-testid="message-box"
    >
      <p>{content}</p>

      <CheckBox
        onChange={onNotShowChange}
        text={checkBoxText}
        valueState={checkBoxValueState}
        wrappingType={checkBoxWrap}
        style={{ marginLeft: -11, ...checkBoxStyle }}
        data-testid="dont-show-checkbox"
      />
    </MessageBox>
  );
});
